import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Row,
  Col,
  Select,
  Spin,
  Badge,
  Tooltip,
} from "antd";
import { Link } from "react-router-dom";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { GetQuizApi, GetTypeQuestionApi } from "api/getQuiz";
import {
  errorHandle,
} from "../../../Function";
import "./ViewQuestion.css";
import ModalCreateQuiz from "./ModalQuiz/ModalCreateQuiz";
import {
  FileAddOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const getColumns = ({ pager }) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    align: "center",
    render: (value, item, index) =>
      ((pager.current || 1) - 1) * pager.pageSize + index + 1,
    // sortDirections: ["descend", "ascend", "descend"],
    // ellipsis: true,
    type: "text",
    width: 20,
    // fixed: "left",
  },
  {
    title: "Nhóm/Bộ",
    dataIndex: "note",
    key: "note",
    filterKey: "note",
    align: "center",
    type: "text",
    width: 50,
    // render: name => name
  },
  {
    title: "Câu hỏi",
    dataIndex: "cau_hoi",
    key: "cau_hoi",
    filterKey: "cau_hoi",
    type: "text",
    width: 150,
  },
  {
    // title: "Đáp án lựa chọn",
    title: (
      <div
        style={{
          // display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Đáp án lựa chọn</span>
        <Tooltip
          placement="top"
          title={"Đáp án đúng sẽ hiển thị chữ màu đỏ"}
          arrowPointAtCenter={true}
        >
          <span
            style={{
              float: "right",
              marginRight: "25px",
            }}
          >
            <InfoCircleOutlined />
          </span>
        </Tooltip>
      </div>
    ),
    dataIndex: "dap_an",
    key: "dap_an",
    filterKey: "dap_an",
    width: 150,
    type: "text",
    render: (item, record) => (
      <div>
        {item.map((option, index) => (
          <div
            key={index}
            style={record.dap_an_dung.split("+").map(Number).includes(index + 1) ? { color: "red" } : null}
          >
            {index + 1}. {option}
          </div>
        ))}
      </div>
    ),
  },
];

const ViewQuestion = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_page, setLoading_page] = useState(false);
  const [arrTypeQuestion, setArrTypeQuestion] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isShowCreateQuiz, setIsShowCreateQuiz] = useState(false);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const columns = getColumns({ pager });

  const fetchDataQuiz = (params = {}) => {
    setLoading(true);
    GetQuizApi(params)
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchTypeQs = (params = {}) => {
    setLoading(true);
    GetTypeQuestionApi(params)
      .then((res) => {
        setArrTypeQuestion(res.data.results);
        setSelectedGroup(res.data.results[0]["id"]);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchTypeQs();
  }, []);

  useEffect(() => {
    fetchDataQuiz({
      question_type: selectedGroup,
    });
  }, [selectedGroup]);

  const onChangeGroup = (value) => {
    setSelectedGroup(value);
  };

  const onCancelCreateQuiz = () => {
    setIsShowCreateQuiz(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Bộ đề thi</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">ISMS</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/isms/question">Đề thi</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Row
          // gutter={[8, 8]}
          style={{ float: "left" }}
        >
          <Col>
            <div className="sl-group m-2">
              <Badge.Ribbon text="Nhóm" color="gray" style={{ color: "red" }}>
                <Select value={selectedGroup} onChange={onChangeGroup}>
                  {arrTypeQuestion &&
                    arrTypeQuestion.map((item, index) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.note} ({item.loai_cau_hoi})
                      </Select.Option>
                    ))}
                </Select>
              </Badge.Ribbon>
            </div>
          </Col>
          <Col>
            <Button
              ghost
              type="success"
              className={"m-2"}
              onClick={() => setIsShowCreateQuiz(true)}
              icon={<FileAddOutlined />}
            >
              Tạo đề
            </Button>
          </Col>
        </Row>
      </div>
      <Spin spinning={loading_page}>
        <div className="row">
          <Table
            dataSource={data}
            columns={columns}
            loading={loading}
            className={"custom-table-hover style-6"}
            bordered={true}
            // scroll={data.length > 0 && { x: 1840, y: 500 }}
            size={"small"}
            rowKey="id"
            pagination={false}
          />
        </div>
      </Spin>
      {isShowCreateQuiz && (
        <ModalCreateQuiz
          open={isShowCreateQuiz}
          onCancel={onCancelCreateQuiz}
          arrTypeQuestion={arrTypeQuestion}
          setSelectedGroup={setSelectedGroup}
          fetchDataQuiz={fetchDataQuiz}
        />
      )}
    </>
  );
};

export default ViewQuestion;
